/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type MarkHardwareRequestAsReadyMutationVariables = Types.Exact<{
  id: Types.Scalars["Float"];
}>;

export type MarkHardwareRequestAsReadyMutation = {
  markHardwareRequestAsReady: Pick<Types.HardwareRequest, "id" | "status"> & {
    user: Pick<Types.User, "id" | "name" | "email">;
    hardware_item_requests: Array<
      Pick<Types.HardwareItemRequest, "id" | "quantity"> & {
        HardwareItem: Pick<
          Types.HardwareItem,
          "id" | "sku_code" | "total_quantity" | "available_quantity"
        >;
      }
    >;
  };
};

export const MarkHardwareRequestAsReadyDocument = gql`
  mutation MarkHardwareRequestAsReady($id: Float!) {
    markHardwareRequestAsReady(id: $id) {
      id
      status
      user {
        id
        name
        email
      }
      hardware_item_requests {
        id
        quantity
        HardwareItem {
          id
          sku_code
          total_quantity
          available_quantity
        }
      }
    }
  }
`;

/**
 * __useMarkHardwareRequestAsReadyMutation__
 *
 * To run a mutation, you first call `useMarkHardwareRequestAsReadyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkHardwareRequestAsReadyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markHardwareRequestAsReadyMutation, { data, loading, error }] = useMarkHardwareRequestAsReadyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkHardwareRequestAsReadyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    MarkHardwareRequestAsReadyMutation,
    MarkHardwareRequestAsReadyMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    MarkHardwareRequestAsReadyMutation,
    MarkHardwareRequestAsReadyMutationVariables
  >(MarkHardwareRequestAsReadyDocument, baseOptions);
}
export type MarkHardwareRequestAsReadyMutationHookResult = ReturnType<
  typeof useMarkHardwareRequestAsReadyMutation
>;
export type MarkHardwareRequestAsReadyMutationResult =
  ApolloReactCommon.MutationResult<MarkHardwareRequestAsReadyMutation>;
export type MarkHardwareRequestAsReadyMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    MarkHardwareRequestAsReadyMutation,
    MarkHardwareRequestAsReadyMutationVariables
  >;
